module.exports = __webpack_public_path__ + "static/media/remote-key-dispensing-banner1.3bfe5bd0.png";